import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { SvgIconComponent } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import ArchiveIcon from '@mui/icons-material/ArchiveOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import LoginIcon from '@mui/icons-material/Login';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RateReviewIcon from '@mui/icons-material/RateReview';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

const ACTION_ICONS: Record<string, SvgIconComponent> = {
    Edit: EditIcon,
    Archive: ArchiveIcon,
    Delete: DeleteIcon,
    Reactivate: UnarchiveIcon,
    Duplicate: ContentCopyIcon,
    View: VisibilityIcon,
    'View/Edit': EditIcon,
    Impersonate: SupervisorAccountIcon,
    Access: LoginIcon,
    Complete: CheckCircleIcon,
    Review: RateReviewIcon,
    'Resend Verification': MarkEmailReadIcon,
    'Sending...': MarkEmailReadIcon
};

type TableButtonProps = IconButtonProps & {
    tooltip?: string; // tooltip text to display when hovering over the button
};

const TableButton = ({ children, disabled, tooltip, ...props }: TableButtonProps) => {
    const label = typeof children === 'string' ? children.trim() : '';
    const Icon = ACTION_ICONS[label];

    return (
        <Tooltip title={tooltip ?? label}>
            <span>
                <IconButton size="small" disabled={disabled} aria-label={label} {...props}>
                    {Icon ? <Icon sx={label === 'Duplicate' ? { fontSize: 20 } : undefined} /> : label}
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default TableButton;
